import React, { useEffect, useState } from 'react'
import { QUEUE_STRINGS } from '../../utils/queueIntake.types'
import {
  CaseDocumentProps,
  DocumentItemType,
  SelectCaseProps,
} from '../../utils/types'
import {
  CustomButton,
  CustomTable,
  EmptyTableIcon,
  Loader,
  Modal,
  Pagination,
  SelectDropDown,
  SORT_KEYS,
  SvgEdit,
  SvgView,
  TableActionType,
  TableColumnType,
  TableFilterObjectBody,
  Tooltip,
} from '@ui-kit'
import {
  addToaster,
  attachCaseById,
  createWorkflowInstance,
  DataType,
  DataTypeStore,
  patchAttachForHcpEntity,
  ErrorResponse,
  fetchTypeStatusForCommunications,
  getEntityDataByEntityIdLayoutIdApiForFilter,
  getLayoutTree,
  hideLoader,
  showLoader,
  updateWorkflowDefinition,
  updateWorkflowInstance,
  WorkflowDefinitionsListType,
  fetchDocumentIdForHcpEntity,
  fetchCaseDocumentIdForHcpEntity,
  getGenericEntityListingAPI,
  GetGenericEntityListingApiType,
  SearchCriteriaByColumnNames,
  EntityLookupSearchCriteria,
  TableFilterLookupObjectBody,
  GetEntityDataByNameIdFilter,
  getAllWorkflowListUsingServiceId,
  getParamFromURL,
  fetchServiceListAPI,
  fetchWorkflowDefinitionsAPI,
  CreateChildInstanceType,
  fetchCaseIdUsingWorkFlowAndDefinitionId,
  getAllLayoutApi,
  getEntityList,
  workflowCaseMappingForWebEnrollment,
  updateWorkflowInstanceAdditionalKeys,
} from '@app-store'
import { isEmpty, isNull, noop, uniqueId } from 'lodash'
import './IntakeQueue.css'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import {
  COMM_TEMPLATE,
  DUPLICATE_POPUP,
  COLUMN_ACTIONS,
  ENTITY_FIELDS,
  ENTITY_NAME,
  FIELD_VALUE_CONSTANTS,
  LAYOUT_TYPE_NAMESPACE,
  MODE_CONSTANTS,
  NAMESPACES,
  NAMESPACES_MANUAL_COMMUNICATION,
  PERMISSION_MODULES,
  REPORTS,
  RECORD_STATE,
} from '../../utils/constants'
import { LayoutDataObject } from '../../types/layout.types'
import {
  formatDataForListView,
  transformLayoutToCols,
  formatFilterConfig,
} from '../../utils/listing.utils'
import AddEditRecordPage from '../AddEditViewRecord.page'
import { useNavigate, useParams } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import { DYNAMIC_QUEUE_MESSAGES } from '../../constants/dynamicQueue'
import {
  CHECK_ATTACH_IF_CASE,
  EMAIL_PREVIEW,
  INTAKE_CASE_VIEW__LISTING_COLUMNS,
} from '../../constants/intakeQue.constants'
import { FieldValues } from 'react-hook-form'
import {
  fetchEntityIdByName,
  fetchLayoutIdByEntityId,
  logErrorMessage,
  mergeFilters,
  mergeRelatedEntities,
  openNewWindow,
  permissionObject,
} from '../../utils/helperFunctions'
import { AxiosError } from 'axios'
import {
  editEntityDataEmbeddedAPI,
  getEntityDataByIdEntityNameEmbedded,
  mapWebEnrollmentWithCase,
} from '../../apis/entityData.api'
import { EntityDataByEntityFilterPayload } from '../../types/types'
import RequesterSearchForm, {
  AdvancedSearchInfo,
} from '../call-interaction/RequestorSearchForm'
import { SelectWorkFlowDropDown } from '../call-interaction/SearchLayout'
import { CaseDetails } from '../../types/intakeQueue.types'
import {
  checkIfFromAttachCase,
  handleOpenLink,
} from '../../utils/dynamic-queue'
import { getCurrentLocalDate } from '../../utils/date.utils'
import { IntakeReviewLayoutWrapper } from './IntakeReviewLayoutWrapper'

const SelectCase: React.FC<SelectCaseProps> = ({
  intakeType,
  programName,
  programId,
  productId,
  requestorId,
  unlockOnAttach,
  handleWorkFlowCaseCreate,
  entityName,
  faxDetails,
  updateStatusToCompleted,
  handleShowIntakeLayoutForChildCase,
  updateStatusToProcessing,
  viewEntityRecord,
  maxHeight = '',
}: SelectCaseProps) => {
  const intialFilter: TableFilterObjectBody = {
    fields: null,
    search_criteria: {
      program_id: {
        search_key: '',
        search_value: [programName?.id?.toString() ?? ''],
        operator: 'EQUALS',
      },
    },
  }
  const initialDirection: {
    keyName: string
    direction: SORT_KEYS
    isAsc: SORT_KEYS
    key: string
  } = {
    key: 'name',
    isAsc: SORT_KEYS.Asc,
    keyName: 'name',
    direction: SORT_KEYS.Asc,
  }
  const { communicationId, caseEntityId, entityid: entityId } = useParams()
  const [layoutIdForHcpEntity, setLayoutIdForHcpEntity] = useState<number>()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  //list of workflow
  const [workflowList, setWorkflowList] = useState<
    WorkflowDefinitionsListType[]
  >([])
  const [workflowListUsingService, setWorkflowListUsingService] = useState<
    WorkflowDefinitionsListType[]
  >([])

  const relationshipTree = useAppSelector(
    (state) => state?.workflowData?.relationshipTree
  )
  const categoryDropdown = useAppSelector(
    (state) => state?.categoryDropdown?.categoryMap
  )
  const intakeCommunicationMap = useAppSelector(
    (state) => state?.workflowData?.intakeCommunicationMap
  )

  const entitiesList = useAppSelector(
    (state: RootState) => state.entity.entities
  )
  const [advanceFilterApplied, setAdvanceFilterApplied] =
    useState<boolean>(false)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [tableFilterApplied, setTableFilterApplied] = useState<boolean>(false)
  const [entityData, setEntityData] = useState<DataType[]>([])
  const [totalPages, setTotalPages] = useState<number>(1)
  const [layoutData, setLayoutData] = useState<LayoutDataObject>()
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [loading, setLoading] = useState<boolean>(false)
  const [aepcData, setAepcData] = useState<Record<number, number>>({})
  const [rowsPerPage, setRowsPerPage] = useState<number>(
    FIELD_VALUE_CONSTANTS.TEN
  )
  const [advancedFiltersData, setAdvancedFiltersData] = useState<
    AdvancedSearchInfo | undefined
  >()
  const [editCaseRcord, setEditCaseRecord] = useState<boolean>(false)
  const [viewCaseRecord, setViewCaseRecord] = useState<boolean>(false)
  const recordId = getParamFromURL('caseId')
  const [openCaseDetails, setOpenCaseDetails] = useState<CaseDetails>({
    value: false,
    id: '',
    type: '',
  })
  const [headerValues, setHeaderValues] = useState<DataTypeStore>({
    selected: false,
  })
  const [apiFilter, setApiFilter] = useState<TableFilterObjectBody | undefined>(
    undefined
  )

  const [caseViewEntityId, setCaseViewEntityId] = useState<number>(0)
  const [sortDirection, setSortDirection] = useState<{
    keyName: string
    direction: SORT_KEYS
    isAsc: SORT_KEYS
    key: string
  }>(initialDirection)
  const authUser = useAppSelector((state) => state.authUser)
  const [modal, setModal] = useState<{
    state: boolean
    documentId: number | null
  }>({
    state: false,
    documentId: null,
  })
  const [caseId, setCaseId] = useState<
    string | number | boolean | string[] | number[]
  >('')
  const [entityDataPayload, setEntityDataPayload] = useState<{
    payload: GetEntityDataByNameIdFilter
    fromSearch?: boolean
  }>()
  const [fetchKey, setFetchKey] = useState<number>(0)

  const [colList, setColList] = useState<
    (TableColumnType<DataTypeStore> & { componentName: string })[]
  >([])
  const { programPermissions } = useAppSelector(
    (state) => state?.clientPermissions
  )
  const categoryData = useAppSelector(
    (state) => state?.categoryDropdown?.categoryMap
  )
  const [hasManagePermission, setHasManagePermission] = useState(false)

  const [caseDocumentId, setCaseDocumentId] = useState<number | string>('')
  const [allServices, setAllServices] = useState<
    { service_name: string; id: number }[]
  >([])

  const actions: TableActionType<DataTypeStore>[] = [
    {
      label: NAMESPACES.VIEW_360,
      key: NAMESPACES.VIEW_360_KEY,
      showInPopUp: false,
      isEnabledOnDisabledRow: false,
      type: 'component',
      renderActionComponent: (_row, _rowIndex, _onActionClick, isDisabled) => {
        if (isDisabled) {
          return <SvgView color={'#5E5E5E'} pathClass="fill-accent-600" />
        }
        return (
          <button
            type="button"
            onClick={() =>
              _onActionClick(NAMESPACES.VIEW_360_KEY, _row, _rowIndex)
            }
          >
            <SvgView />
          </button>
        )
      },
    },
    {
      label: NAMESPACES.ATTACH,
      key: NAMESPACES.ATTACH,
      showInPopUp: false,
      isEnabledOnDisabledRow: false,
      type: 'component',
      renderActionComponent: (_row, _rowIndex, _onActionClick) => {
        return (
          <Tooltip content={NAMESPACES.ATTACH} position="top">
            <button
              type="button"
              onClick={() => attachmentSubmit(_row?.id)}
              className="flex items-center justify-center font-normal text-xs w-[4.313rem] h-[1.75rem] rounded border border-primary-500 hover:bg-primary-100"
            >
              <div>{NAMESPACES.ATTACH}</div>
            </button>
          </Tooltip>
        )
      },
    },
    {
      label: REPORTS.CREATE_CASE,
      key: REPORTS.CREATE_CASE_KEY,
      showInPopUp: false,
      type: 'component',
      renderActionComponent: (row: DataTypeStore) => {
        return (
          <SelectWorkFlowDropDown
            workflowList={workflowListUsingService ?? []}
            updateSelectWorkflow={(
              selectedWorkflow: WorkflowDefinitionsListType
            ) => {
              createWorkflowInstanceForSelected(selectedWorkflow, row, false)
            }}
            onDropDownClick={() => {
              fetchWorkFlowInstanceUsingServiceId(
                Number(row['prc_def_id']),
                Number(row['program_id'])
              )
            }}
          />
        )
      },
    },
  ]
  // TODO: may require later
  // const updateSelectWorkflow = (data) => {
  //   setSelectedWorkflow(data)
  // }
  useEffect(() => {
    const fetchAepcData = async () => {
      if (intakeType === NAMESPACES?.FAX_UPPERCASE || !faxDetails?.id) return

      const payload = {
        entity_name: ENTITY_NAME?.AE_PC_DOCUMENT,
        select: [NAMESPACES?.DOCUMENTS],
        filters: [
          {
            logical_operator: 'AND',
            criteria: [
              {
                values: [faxDetails?.id],
                operation: 'EQUALS',
                field_name: 'web_enrollment_id',
              },
            ],
          },
        ],
      }

      const response = await getGenericEntityListingAPI(
        payload as unknown as GetGenericEntityListingApiType
      )

      if (!response) return

      const aepcMap: Record<number, number> = {}

      response.forEach((enrollment: FieldValues) => {
        const docId = enrollment?.documents?.id
        const enrollmentId = enrollment?.id

        if (docId && enrollmentId) {
          aepcMap[docId] = enrollmentId
        }
      })
      setAepcData(aepcMap)
    }

    fetchAepcData()
  }, [faxDetails?.id, intakeType])

  const handleSelected = (
    isHeader: boolean,
    rowIndex: number | null,
    row?: DataTypeStore | null
  ) => {
    if (isHeader) {
      const selected = headerValues?.selected
      setEntityData(
        entityData.map((dataItem) => ({
          ...dataItem,
          selected: !selected,
        }))
      )
      setHeaderValues((prev) => {
        return { ...prev, selected: !prev?.selected }
      })
    } else if (
      !isNull(rowIndex) &&
      rowIndex >= 0 &&
      rowIndex < entityData.length
    ) {
      const newState = [...entityData]
      const element = { ...newState[rowIndex] }
      element.selected = !element.selected
      newState[rowIndex] = element
      setHeaderValues((prev) => {
        return { ...prev, selected: newState[rowIndex]?.selected }
      })
      setEntityData([...newState])
    }

    row && setCaseId(row?.id)
  }

  const onColumnClick = (
    isHeader: boolean,
    KeyName: keyof DataTypeStore,
    row?: DataTypeStore | null,
    rowIndex: number | null = null
  ) => {
    switch (KeyName) {
      case COLUMN_ACTIONS.SELECTED:
        handleSelected(isHeader, rowIndex, row)
        break
      case NAMESPACES.CASE_KEY:
      case NAMESPACES.CASE_ID_KEY:
        window.open(`entity/${caseEntityId}/workflow/review/${row?.id}`)
        break
      default:
        break
    }
  }

  // TODO: may require later
  // const handleClear = () => {
  //   setApiFilter(undefined)
  //   setEntityData([])
  //   setTotalPages(0)
  //   setCurrentPage(0)
  //   setSortDirection(initialDirection)
  // }

  const handleTableActions = async (
    actionKeyName: string,
    row: DataTypeStore
  ) => {
    try {
      if (
        actionKeyName === MODE_CONSTANTS.VIEW_360 &&
        row?.id &&
        caseEntityId
      ) {
        dispatch(showLoader())
        const serviceId =
          allServices.find((service) => service.service_name === row.case_type)
            ?.id ?? 0
        const layoutId = await handleOpenLink(
          row?.id as number,
          +caseEntityId,
          serviceId,
          false,
          navigate,
          true
        )
        setOpenCaseDetails({
          value: true,
          id: String(row?.id),
          type: MODE_CONSTANTS.VIEW,
          layoutId: layoutId,
        })
        setViewCaseRecord(true)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const onSortClick = (key: string, isAsc: SORT_KEYS) => {
    if (key) {
      setSortDirection({
        keyName: isAsc === SORT_KEYS.Disabled ? '' : key,
        direction: isAsc,
        key: isAsc === SORT_KEYS.Disabled ? '' : key,
        isAsc: isAsc,
      })
    }
  }

  const onCloseDetailsModal = (
    val: boolean,
    view?: string,
    fromSave = false
  ) => {
    setOpenCaseDetails({ value: val, id: '', type: '' })
    if (fromSave) {
      view !== MODE_CONSTANTS.VIEW &&
        navigate(`/entity/${caseEntityId}/workflow/review/${caseId}`)
      return
    }
    view !== MODE_CONSTANTS.VIEW && navigate('../')
  }
  const attachmentSubmit = (
    id: string | number | boolean | string[] | number[] | null
  ) => {
    setCaseId(id ?? '')
    onSubmit(NAMESPACES?.NO_REASON, id?.toString() ?? '')
  }

  const isAnyOtherKeyPresent = (
    search_criteria: SearchCriteriaByColumnNames | undefined
  ): boolean => {
    if (!search_criteria) return false
    const keys = Object.keys(search_criteria)
    return keys.some((key) => key !== 'program_id')
  }
  const onFilterChange = (value: TableFilterObjectBody) => {
    setTableFilterApplied(isAnyOtherKeyPresent(value?.search_criteria))
    setApiFilter(value)
  }
  const fetchData = async () => {
    try {
      setLoading(true)
      const entityViewIds: Record<string, number> = {
        [ENTITY_NAME.CASE_VIEW_KEY]: 0,
      }

      entitiesList.forEach((entity: { name: string; id: number }) => {
        if (entity.name in entityViewIds) {
          entityViewIds[entity.name] = entity.id ?? 0
        }
      })

      setCaseViewEntityId(entityViewIds[ENTITY_NAME.CASE_VIEW_KEY])
      const layouts = await getAllLayoutApi({
        entityId: entityViewIds[ENTITY_NAME.CASE_VIEW_KEY]?.toString() ?? '0',
        defaultValue: true,
        type: LAYOUT_TYPE_NAMESPACE.LAYOUT_LISTING,
      })
      const layout = layouts?.data?.content

      if (layout[0]?.layout_data) {
        setLayoutData(layout[0])
        const tableHeader = transformLayoutToCols(
          layout[0],
          Number(caseEntityId),
          LAYOUT_TYPE_NAMESPACE.DEFAULT_LAYOUT_LISTING
        )
        tableHeader.forEach((col) => (col.filterData = undefined))
        setColList(tableHeader)
      }
    } catch (err) {
      logErrorMessage('layout', err)
      setEntityData([])
    } finally {
      setLoading(false)
    }
  }

  const fetchEntityData = async (page?: number, rows?: number) => {
    try {
      setLoading(true)
      const formatFilter: {
        filter_criteria: EntityLookupSearchCriteria[]
        related_entities: TableFilterLookupObjectBody
      } = apiFilter
        ? (formatFilterConfig(apiFilter ?? {}, colList, 'Entity', {
            key: sortDirection?.key ?? '',
            direction: sortDirection?.direction?.toUpperCase() ?? '',
          }) as {
            filter_criteria: EntityLookupSearchCriteria[]
            related_entities: TableFilterLookupObjectBody
          })
        : { filter_criteria: [], related_entities: {} }
      const entity = await getEntityDataByEntityIdLayoutIdApiForFilter({
        payload: {
          entity_id: caseViewEntityId?.toString() ?? '',
          select: [
            ...new Set([
              ...(entityDataPayload?.payload?.payload?.select ?? []),
              ...(INTAKE_CASE_VIEW__LISTING_COLUMNS ?? []),
              ...(caseViewEntityId > 0 ? ['program_id', 'prc_def_id'] : []),
            ]),
          ],
          page: page ? page - 1 : currentPage - 1,
          size: rows ?? rowsPerPage,
          related_entities: mergeRelatedEntities(
            entityDataPayload?.payload?.payload?.related_entities,
            {
              ...formatFilter.related_entities,
            }
          ),
          filters: mergeFilters(
            entityDataPayload?.payload?.payload?.filters,
            formatFilter.filter_criteria
          ),
        } as EntityDataByEntityFilterPayload,
        entityName: ENTITY_NAME.CASE_VIEW_KEY ?? '',
      })
      setEntityData(
        formatDataForListView(entity?.data?.content, layoutData?.layout_data)
      )
      setTotalPages(entity?.data?.totalPages)
      setTotalRecords(entity?.data?.totalElements)
    } catch (err) {
      logErrorMessage('entity', err)
      setEntityData([])
    } finally {
      setLoading(false)
    }
  }

  const handlePageChange = async (page: number, rows: number) => {
    setRowsPerPage(rows)
    const currentPage = rows !== rowsPerPage ? 1 : page
    setCurrentPage(currentPage)
    fetchEntityData(currentPage, rows)
  }

  // const removeFormatting = (phone: string) => { //TODO: Might Need later
  //   const cleaned = phone.replace(/\D/g, '')
  //   return `+1 ${cleaned.slice(1, 11)}`
  // }

  const handleHcpEntityAttachment = async (id: number | string) => {
    const statusId = await fetchWebEnrollmentStatusId()
    if (!statusId) return

    const attached = await patchAttachForHcpEntity(
      [communicationId ?? ''],
      entityId ?? '',
      layoutIdForHcpEntity?.toString() ?? '',
      id ?? caseId?.toString(),
      statusId.toString()
    )

    if (!attached) return

    unlockOnAttach.current = false
    showSuccessToast()

    const caseDocumentId = await fetchCaseDocumentId(id)
    if (caseDocumentId) {
      setModal({ state: true, documentId: parseInt(caseDocumentId) })
    }
  }

  const handleDefaultEntityAttachment = async (
    id: number | string,
    reason: string,
    reviewer: string
  ) => {
    const response = await attachCaseById({
      faxId: communicationId ?? '',
      caseId: id ?? caseId,
      reason,
      reviewer,
    })

    if (response) {
      setModal({
        state: true,
        documentId: response?.data?.document_entities?.id,
      })
    }

    unlockOnAttach.current = false
    showSuccessToast()
  }

  const showSuccessToast = () => {
    dispatch(
      addToaster({
        message: QUEUE_STRINGS.CASE_ATTACHED,
        type: 'success',
        id: uuid(),
      })
    )
  }

  const fetchWebEnrollmentStatusId = async (): Promise<string | undefined> => {
    const response = await fetchTypeStatusForCommunications(
      'web-enrollment-status'
    )
    return response?.data?.find(
      (item: { value: string }) =>
        item?.value?.toLowerCase() === NAMESPACES.PROCESSING_LOWERCASE
    )?.id
  }

  const fetchCaseDocumentId = async (
    id: number | string
  ): Promise<string | undefined> => {
    const entityData = await fetchEntityIdByName(
      dispatch,
      NAMESPACES.WEB_ENROLLMENT_DOCUMENT
    )
    if (!entityData) return

    const documents = await fetchDocumentIdForHcpEntity(
      entityData?.id.toString() ?? '',
      faxDetails?.enrollment_id ?? ''
    )

    const matchedDoc = documents?.data?.content?.find(
      (item: { enrollment_id: string }) =>
        item?.enrollment_id === faxDetails?.enrollment_id
    )

    if (!matchedDoc?.document?.id) return

    const caseDocEntity = await fetchEntityIdByName(
      dispatch,
      NAMESPACES.CASE_DOCUMENTS
    )
    if (!caseDocEntity) return

    const layout = await fetchLayoutIdByEntityId(
      dispatch,
      caseDocEntity.id,
      QUEUE_STRINGS.EDIT_MODE
    )
    const layoutId = layout?.find(
      (item: { entity_name: string }) =>
        item?.entity_name === NAMESPACES.CASE_DOCUMENTS
    )?.id

    if (!layoutId) return

    const caseDocmentTypeId = categoryData?.[
      COMM_TEMPLATE?.CASE_DOCUMENT_TYPE
    ]?.find((item) => item.value === DUPLICATE_POPUP?.INTAKE_FORM)?.id

    const caseDocument = await fetchCaseDocumentIdForHcpEntity(
      caseDocEntity.id.toString(),
      layoutId.toString(),
      id ?? caseId,
      matchedDoc.document.id.toString(),
      faxDetails?.enrollment_id,
      caseDocmentTypeId
    )

    return caseDocument?.data?.id
  }

  function handleAttachError(err: unknown) {
    console.error(err)
    const response = (err as AxiosError)?.response?.data as ErrorResponse

    if (response?.fieldErrors?.length) {
      response.fieldErrors.forEach(({ message }) =>
        dispatch(
          addToaster({
            message: message ?? QUEUE_STRINGS.ERROR_DISCARDING_CASE,
            type: 'error',
            id: uuid(),
          })
        )
      )
    } else {
      dispatch(
        addToaster({
          message: response?.message ?? DYNAMIC_QUEUE_MESSAGES.ERROR_MESSAGE,
          type: 'error',
          id: uuid(),
        })
      )
    }
  }

  const onSubmit = async (reason: string, id: number | string) => {
    try {
      dispatch(showLoader())

      const reviewer = `${authUser?.user?.first_name} ${authUser?.user?.last_name}`

      if (entityName === QUEUE_STRINGS.HCP_PORTAL_ENTITY_LOWERCASE) {
        await handleHcpEntityAttachment(id)
      } else {
        await handleDefaultEntityAttachment(id, reason, reviewer)
      }
      updateStatusToProcessing()
    } catch (err) {
      handleAttachError(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const onSearch = async () => {
    setCurrentPage(1)
    setApiFilter(intialFilter)
    setAdvanceFilterApplied(true)
  }
  const getCaseScreen = () => {
    if (!programName) return null
    return (
      <div className="w-full bg-secondary-25 py-14 flex flex-col items-center mt-4 gap-4 ">
        <div>
          <EmptyTableIcon />
        </div>
        <div>
          <div className="text-xs/5 text-center font-light font-primary text-accent-900">
            {DYNAMIC_QUEUE_MESSAGES.NO_PERMISSIONS_MESSAGE}
          </div>
          <div className="text-xs/5 text-center font-light font-primary text-accent-900">
            {DYNAMIC_QUEUE_MESSAGES.No_PERMISSION_SUBTEXT}
          </div>
        </div>
      </div>
    )
  }

  const fetchWorkFlowInstance = async () => {
    try {
      if (programId && productId) {
        let serviceIds: Set<number> | undefined = undefined
        const allowedServices = await fetchServiceListAPI(programId, productId)
        if (allowedServices?.data) {
          serviceIds = new Set(
            allowedServices.data.map((service: { id: number }) => service.id)
          )
        }
        const searchCriteria = [
          {
            search_key: 'PROGRAM_ID',
            search_value: [programId],
            operator: 'EQUALS',
          },
          {
            search_key: 'SERVICE_ID',
            search_value: Array.from(serviceIds ?? []).map(String),
            operator: 'EQUALS',
          },
          {
            search_key: 'INDEPENDENT',
            search_value: ['true'],
            operator: 'EQUALS',
          },
          {
            search_key: 'RECORD_STATUS',
            search_value: ['ACTIVE'],
            operator: 'EQUALS',
          },
        ]
        const response = await fetchWorkflowDefinitionsAPI(searchCriteria)
        if (response?.data) {
          setWorkflowList(
            response.data.content.filter(
              (item: WorkflowDefinitionsListType) =>
                !item.name
                  ?.toLowerCase()
                  .includes(NAMESPACES.DO_NOT_USE?.toLowerCase())
            )
          )
        }
      }
    } catch (err) {
      logErrorMessage('workflow instance', err)
    }
  }

  const fetchWorkFlowInstanceUsingServiceId = async (
    definitionId: number,
    programId: number
  ) => {
    try {
      setWorkflowListUsingService([])
      dispatch(showLoader())
      const response = await getAllWorkflowListUsingServiceId(
        definitionId,
        programId
      )
      if (response.data) {
        const data = response?.data ?? []
        setWorkflowListUsingService(
          data?.filter(
            (item: WorkflowDefinitionsListType) =>
              !item.name
                ?.toLowerCase()
                .includes(NAMESPACES.DO_NOT_USE?.toLowerCase())
          )
        )
      }
    } catch (err) {
      logErrorMessage('workflow instance using definition id', err)
    } finally {
      dispatch(hideLoader())
    }
  }

  // TODO
  // create case with out selecting workflow

  // const handleClickCreateButton = async () => {
  //   // if (!isEmpty(selectedWorkflow)) {
  //   //   createWorkflowInstanceForSelected()
  //   // } else {
  //   try {
  //     setLoading(true)
  //     unlockOnCreateCase.current = false
  //     setIsInitialSave(true)
  //     await draftCaseCreate()
  //     setLoading(false)
  //   } catch (err) {
  //     console.error(err)ument_id
  //   }
  //   // }
  // }

  //TODO

  const getDoccumentId = async (
    selectedWorkflow: WorkflowDefinitionsListType
  ): Promise<{
    documentId: DocumentItemType[]
    intakeChannel: string | undefined
  }> => {
    if (intakeType === 'FAX') {
      const res = await getEntityDataByIdEntityNameEmbedded(
        selectedWorkflow?.global_variables?.associated_variables?.fax
          ?.parent_entity ?? '',
        ['document_id'],
        communicationId ?? ''
      )
      return {
        documentId: [{ docId: res?.data?.document_id }],
        intakeChannel:
          intakeCommunicationMap?.[
            faxDetails?.category_communication_type?.id ?? 0
          ],
      }
    } else {
      const documentId: DocumentItemType[] = []
      //TODO FILTER
      // const res = await getEntityDataByIdEntityNameEmbedded(
      //   'web_enrollment_document',
      //   ['enrollment_id', 'document']
      // )
      const payload = {
        entity_name: 'web_enrollment_document',
        select: ['enrollment_id', 'document', 'status', 'name'],
        filters: [
          {
            logical_operator: 'AND',
            criteria: [
              {
                values: [faxDetails?.enrollment_id],
                operation: 'LIKE',
                field_name: 'enrollment_id',
              },
            ],
          },
        ],
      }
      const response = await getGenericEntityListingAPI(
        payload as unknown as GetGenericEntityListingApiType
      )
      // if (res?.data) {
      //   res?.data.forEach((enrollment: FieldValues) => {
      //     //TODO signed doc (might be used later)
      //     if (enrollment?.enrollment_id === faxDetails?.enrollment_id) {
      //       documentId?.push(enrollment?.document?.id)
      //     }
      //   })
      // }

      if (response) {
        const categoryData = categoryDropdown?.['web_enrollment_document']

        response?.forEach((enrollment: FieldValues) => {
          const selectedValue = categoryData?.find(
            (item) => item.value === enrollment?.status
          )
          documentId?.push({
            docId: enrollment?.document?.id,
            web_document_status: selectedValue,
            name: enrollment?.name,
          })
        })
      }

      return { documentId: documentId, intakeChannel: '418' }
    }
  }
  const getEntityIdObj = (
    viewEntityRecord: DataTypeStore | undefined,
    expectedType: string
  ) => {
    return viewEntityRecord?.entity_type === expectedType
      ? {
          id:
            viewEntityRecord?.entity_type === expectedType
              ? Number(viewEntityRecord?.record_id ?? viewEntityRecord?.id)
              : '',
          _state: 'ADDED',
        }
      : undefined
  }

  const createWorkflowInstanceForSelected = async (
    selectedWorkflow: WorkflowDefinitionsListType,
    rightRow?: DataTypeStore,
    isTopDropdown?: boolean
  ) => {
    // TODO: Communication Entity key change
    const communicationEntity = relationshipTree?.filter(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.communication
          ?.entity_id ?? '59')
    )

    const programEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.program?.entity_id ??
          '94')
    )
    const productEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.product?.entity_id ??
          '78')
    )
    const userEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.users?.entity_id ?? '74')
    )
    const requestorEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.requestor?.entity_id ??
          '1161')
    )
    const patientEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.patient?.entity_id ??
          '18')
    )
    const providerEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.providers?.entity_id ??
          '4')
    )

    const caseSummaryEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.case_summary
          ?.entity_id ?? '1311')
    )

    setLoading(true)
    try {
      const { documentId, intakeChannel } = await getDoccumentId(
        selectedWorkflow
      )
      const embedded =
        Object?.keys(
          selectedWorkflow?.global_variables?.inherited_variables ?? {}
        ) ?? []

      const caseCategoryValue = categoryDropdown?.['Case Document Type']
      let caseMapping: FieldValues = {}

      if (intakeType !== 'FAX') {
        const caseMappingResponse = await workflowCaseMappingForWebEnrollment()

        if (caseMappingResponse?.data) {
          caseMapping = caseMappingResponse?.data?.global_variable || {}
        }
      }

      const documentObject = documentId?.map((doc: DocumentItemType) => {
        let caseStatus = 1968
        const docId = doc?.docId
        if (intakeType !== 'FAX') {
          const caseVal =
            caseMapping?.[doc?.web_document_status?.value ?? ''] ?? ''
          const webDoc = caseCategoryValue?.find(
            (item) => item.value === caseVal
          )
          caseStatus = webDoc?.id ?? 1968
        }
        return {
          document_id: doc?.docId,
          case_document_type_id: caseStatus,
          name:
            doc?.name ??
            faxDetails?.enrollment_id ??
            faxDetails?.communication_id,
          ...(aepcData?.[Number(docId)] && {
            c_ae_pc_document: {
              id: aepcData?.[Number(docId)] ?? null,
              _state: RECORD_STATE?.ADDED,
            },
          }),
        }
      })
      const faxReceivedDate =
        selectedWorkflow?.global_variables?.config_fields?.case
          ?.fax_received_date ?? ''
      const receivedDate = faxDetails?.created_at
        ? new Date(faxDetails.created_at).toISOString()
        : ''
      const payload: {
        flow_meta_data: {
          process_definition_id: string
          communication_id: string | undefined
        }
        meta_data: {
          entity_name: string
          embedded: (string | undefined)[]
        }
        data: {
          [key: string]:
            | string
            | undefined
            | { id: string | undefined; _state: string }[]
            | number
            | boolean
        }
      } = {
        flow_meta_data: {
          process_definition_id: selectedWorkflow?.id ?? '',
          communication_id: communicationId ?? '',
        },
        meta_data: {
          entity_name: selectedWorkflow?.global_variables?.entity_name ?? '',
          embedded: [
            ...embedded,
            // communicationEntity?.field_name ?? '',
            ENTITY_FIELDS?.case?.communication ?? '',
            programEntity?.field_name ?? '',
            productEntity?.field_name ?? '',
            requestorEntity?.field_name ?? '',
            providerEntity?.field_name ?? '',
            patientEntity?.field_name ?? '',
            caseSummaryEntity?.field_name ?? '',
            // TODO
            userEntity?.field_name ?? '',
            selectedWorkflow?.global_variables?.associated_variables?.document
              ?.parent_entity,
            'intake_channel_id',
            'source_id',
            'case_start_date',
            ...(faxReceivedDate ? [faxReceivedDate] : []),
          ],
        },
        data: {
          ...(selectedWorkflow?.global_variables?.inherited_variables ?? {}),

          [userEntity?.field_name ?? '']: {
            id: Number(authUser?.user?.id),
            _state: 'ADDED',
          },
          [programEntity?.field_name ?? '']: {
            id: programName?.id,
            _state: 'ADDED',
          },
          [productEntity?.field_name ?? '']: {
            id: Number(productId ?? ''),
            _state: 'ADDED',
          },
          [providerEntity?.field_name ?? '']: getEntityIdObj(
            viewEntityRecord,
            'Provider'
          ),
          [patientEntity?.field_name ?? '']: getEntityIdObj(
            viewEntityRecord,
            'Patient'
          ),
          [caseSummaryEntity?.field_name ?? '']: {
            record_status: 'ACTIVE',
            _state: 'CHANGED',
          },
          [requestorEntity?.field_name ?? '']: requestorId
            ? {
                id: requestorId,
                _state: 'ADDED',
              }
            : undefined,
          ...(selectedWorkflow?.global_variables?.associated_variables?.document
            ?.parent_entity && {
            [selectedWorkflow?.global_variables?.associated_variables?.document
              ?.parent_entity ?? 'c_case_documents_c_cases']: [
              ...(documentObject ?? []),
            ],
          }),
          intake_channel_id: intakeChannel,
          case_start_date: new Date(getCurrentLocalDate()).toISOString(),
          source_id:
            faxDetails?.communication_id ?? faxDetails?.enrollment_id ?? '',
          ...(faxReceivedDate ? { [faxReceivedDate]: receivedDate } : {}),
        },
      }

      if (!isTopDropdown) {
        const reviewer = `${authUser?.user?.first_name} ${authUser?.user?.last_name}`
        const fetchCasePayload: CreateChildInstanceType = {
          process_request: {
            flow_meta_data: {
              process_definition_id: selectedWorkflow.id ?? '',
              communication_id: communicationId ?? '',
            },
            meta_data: {
              entity_name:
                selectedWorkflow?.global_variables?.entity_name ?? '',
              embedded: [
                ...embedded,
                productEntity?.field_name ?? '',
                userEntity?.field_name ?? '',
                'intake_channel_id',
                ...(faxReceivedDate ? [faxReceivedDate] : []),
                requestorEntity?.field_name ?? '',
                selectedWorkflow?.global_variables?.associated_variables
                  ?.document?.parent_entity ?? '',
              ],
            },
            data: {
              source_id:
                faxDetails?.communication_id ?? faxDetails?.enrollment_id ?? '',
              products: {
                id: Number(productId),
                _state: 'ADDED',
              },
              intake_channel_id: intakeChannel,
              request_received_at: receivedDate,
              users: {
                id: Number(authUser?.user?.id),
                _state: 'ADDED',
              },
              requestor: {
                id: requestorId ?? 0,
                _state: 'ADDED',
              },
              ...(selectedWorkflow?.global_variables?.associated_variables
                ?.document?.parent_entity &&
                intakeType !== NAMESPACES_MANUAL_COMMUNICATION.FAX && {
                  [selectedWorkflow?.global_variables?.associated_variables
                    ?.document?.parent_entity ?? 'c_case_documents_c_cases']: [
                    ...(documentObject ?? []),
                  ],
                }),
            },
          },
          procedure_param: {
            show_intake_form: true,
            source_id:
              faxDetails?.communication_id ?? faxDetails?.enrollment_id ?? '',
            case_id: rightRow?.id as number,
          },
        }
        const res = await fetchCaseIdUsingWorkFlowAndDefinitionId(
          fetchCasePayload,
          selectedWorkflow.id ?? '',
          rightRow ? Number(rightRow['prc_def_id']) : 0,
          reviewer ?? '',
          intakeType !== NAMESPACES_MANUAL_COMMUNICATION.FAX
            ? undefined
            : communicationId ?? ''
        )
        if (res?.data) {
          if (intakeType !== NAMESPACES_MANUAL_COMMUNICATION.FAX) {
            const finalHCPData = {
              case_id: res?.data.workflow_instance?.case_id,
            }
            try {
              await editEntityDataEmbeddedAPI(
                res?.data?.process?.global_variables?.entities
                  ?.hcp_portal_entity?.entity_name ?? '',
                faxDetails?.id?.toString() ?? '',
                finalHCPData,
                ['case_id']
              )
            } catch (error) {
              console.error(error)
            }
          }
          const serviceId = res?.data?.process?.service_id
          const caseId = res?.data?.workflow_instance?.case_id
          const workFlowInstance = res?.data
          if (caseId) {
            handleShowIntakeLayoutForChildCase({
              serviceId,
              caseId,
              workFlowInstance,
            })
          }
        }
      } else {
        if (
          communicationEntity?.length &&
          intakeType === NAMESPACES_MANUAL_COMMUNICATION.FAX
        ) {
          communicationEntity.forEach((item) => {
            if (item?.field_name) {
              payload.meta_data.embedded.push(item?.field_name)
              payload.data[item.field_name] = [
                {
                  id: communicationId,
                  _state: 'ADDED',
                },
              ]
            }
          })
        }
        const response = await createWorkflowInstance({
          InstanceId: selectedWorkflow?.id ?? '',
          data: payload,
        })
        if (response?.data) {
          updateStatusToProcessing()
          dispatch(updateWorkflowDefinition(response?.data?.process))
          dispatch(updateWorkflowInstance(response?.data?.workflow_instance))
          dispatch(
            updateWorkflowInstanceAdditionalKeys({
              background_jobs_active: response?.data?.background_jobs_active,
              background_jobs_due_time:
                response?.data?.background_jobs_due_time,
            })
          )
          handleWorkFlowCaseCreate(response?.data?.workflow_instance)
          if (intakeType !== 'FAX') {
            const finalHCPData = {
              case_id: response?.data.workflow_instance.case_id,
            }
            try {
              await editEntityDataEmbeddedAPI(
                response?.data?.process?.global_variables?.entities
                  ?.hcp_portal_entity?.entity_name ?? '',
                faxDetails?.id?.toString() ?? '',
                finalHCPData,
                ['case_id']
              )
            } catch (error) {
              console.error(error)
            }
            await mapWebEnrollmentWithCase(
              response?.data.workflow_instance.case_id ?? '',
              faxDetails?.id?.toString() ?? ''
            )
          }
        }
      }
    } catch (err) {
      const status = (err as AxiosError).response?.status
      const data = (err as AxiosError)?.response?.data
      const message = (data as unknown as { message: string })?.message
      if (status === 409) {
        dispatch(
          addToaster({
            id: uniqueId(),
            message,
            type: 'error',
          })
        )
      }
      logErrorMessage('create workflow instance', err)
    } finally {
      setLoading(false)
    }
  }

  const fetchRelationshipTree = async () => {
    try {
      const response = await getLayoutTree(
        caseEntityId ?? '',
        FIELD_VALUE_CONSTANTS?.ONE?.toString()
      )
      return response
    } catch (error) {
      console.error(error)
    }
  }

  const getSortConfig = (sortDirection: { key: string; isAsc: SORT_KEYS }) => {
    if (!sortDirection?.key || isEmpty(sortDirection.key)) {
      return null
    }
    return {
      key: sortDirection.key,
      isAsc: sortDirection.isAsc,
    }
  }
  const getCaseDetailsType = (type: string) => {
    return type === EMAIL_PREVIEW.VIEW ? 'view' : 'edit'
  }

  const hasPermissionForWorkflow = () => {
    if (hasManagePermission) {
      return (
        <div>
          <div className={`${loading ? 'hidden' : 'visible'}`}>
            <div className="flex justify-between items-center gap-3 border border-100 p-2">
              <div className="headingContent flex flex-col gap-[0.438rem] w-[40.438rem]">
                <span className="text-[0.75rem] text-accent-900 font-primary font-light">
                  {DYNAMIC_QUEUE_MESSAGES.NEW_CASE_MESSAGE}
                </span>
              </div>
              {/* <div className=" flex  items-stretch relative">
              <CustomButton
                type="button"
                color="primary"
                widthClass="w-[8.563rem]"
                className=" border-l-none border-r-2"
                isFilled={true}
                dataQaId="create-new-case"
                onClick={handleClickCreateButton}
              >
                {EMAIL_PREVIEW.CREATE_NEW_CASE}
              </CustomButton>
              <SelectWorkFlowDropDown
                workflowList={workflowList}
                updateSelectWorkflow={createWorkflowInstanceForSelected}
              />
            </div> */}
              <div className="ml-auto">
                <SelectWorkFlowDropDown
                  workflowList={workflowList}
                  updateSelectWorkflow={(
                    selectedWorkflow: WorkflowDefinitionsListType
                  ) => {
                    createWorkflowInstanceForSelected(
                      selectedWorkflow,
                      undefined,
                      true
                    )
                  }}
                  isPink={true}
                  isButtonOnTop={true}
                />
              </div>
            </div>
            <div className="mt-3" />
            <div className="overflow-y-auto border border-1 p-3">
              <div className="mb-4 text-base text-accent-900 font-primary">
                {EMAIL_PREVIEW.SEARCH_AND_CREATE_CASE}
              </div>
              <div className="mt-2">
                <div className="grid grid-cols-3 gap-4 mb-[1.5rem] mt-3">
                  <div className="grid gap-x-1">
                    <SelectDropDown
                      label="Entity Type"
                      options={[
                        {
                          label: 'Case',
                          value: 'case',
                        },
                      ]}
                      name=""
                      onChange={noop}
                      required
                      defaultValue="case"
                      isCrossable={false}
                      disabled={true}
                    />
                  </div>
                  <div className="grid gap-x-1">
                    <SelectDropDown
                      label={'Entity'}
                      options={[
                        {
                          label: 'Case',
                          value: '32',
                        },
                      ]}
                      onChange={noop}
                      name=""
                      required
                      isSearchable
                      defaultValue={'32'}
                      isCrossable={false}
                      disabled={true}
                    />
                  </div>
                  <div className="grid"></div>
                </div>
                <RequesterSearchForm
                  entityType={ENTITY_NAME.CASE}
                  setEntityDataPayload={setEntityDataPayload}
                  setFetchKey={setFetchKey}
                  backToFirstPage={true}
                  advancedFiltersData={advancedFiltersData}
                  setAdvancedFiltersData={setAdvancedFiltersData}
                />
              </div>
              {advanceFilterApplied || tableFilterApplied ? (
                <div className="mt-2">
                  <hr />
                  <div className="justify-between mt-4 items-center">
                    <span className="text-base text-accent-900 font-primary">
                      {EMAIL_PREVIEW.SEARCH_RESULT}
                    </span>
                    <span className="text-xs font-light ml-2">
                      {' '}
                      {totalRecords} {EMAIL_PREVIEW.RESULTS_FOUND}
                    </span>
                  </div>
                  <div className="shadow-[2px_2px_10px_-1px_#00000010] mt-3 rounded-lg">
                    <div className="border border-[var(--Gray-Tones-100,#E3E3E3)] p-1 rounded-lg">
                      <CustomTable
                        columns={colList}
                        data={entityData}
                        actions={actions}
                        headerValues={headerValues}
                        onActionClick={handleTableActions}
                        onColumnClick={onColumnClick}
                        onFilterChange={onFilterChange}
                        filterObject={apiFilter}
                        dataQaId="case-list-table"
                        emptyDataMessage={NAMESPACES.EMPTY_CASE_MESSAGE}
                        maxHeight=""
                        onSortClick={onSortClick}
                        sort={getSortConfig(sortDirection)}
                        showTableColumnOnEmpty={true}
                      />
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-full bg-[#F2F8FF80] py-[3.313rem] flex flex-col items-center mt-4 gap-4">
                  <div>
                    <EmptyTableIcon />
                  </div>
                  <div className="text-xs leading-4.5">
                    {DYNAMIC_QUEUE_MESSAGES.EMPTY_TABLE_QUEUE_MESSAGE}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )
    } else {
      getCaseScreen()
    }
  }

  useEffect(() => {
    fetchRelationshipTree()
  }, [caseEntityId])

  useEffect(() => {
    if (fetchKey > 0) {
      onSearch()
    }
  }, [fetchKey])

  useEffect(() => {
    if (
      layoutData &&
      !!apiFilter?.search_criteria?.program_id?.search_value?.[0] &&
      programName
    )
      fetchEntityData(currentPage, rowsPerPage)
  }, [apiFilter, sortDirection, layoutData])

  useEffect(() => {
    fetchData()
  }, [authUser.selectedClientTenant, communicationId])

  useEffect(() => {
    if (programName?.id) {
      const managePermission = permissionObject?.Manage_Attachments_Manage(
        programPermissions,
        PERMISSION_MODULES.MANAGE_ATTACHMENTS,
        'Manage',
        programName.id?.toString()
      )
      setHasManagePermission(managePermission)
    }
  }, [programPermissions, programName])

  //workflow list fetch
  useEffect(() => {
    const fetchCaseId = async () => {
      const caseEntityData = await fetchEntityIdByName(
        dispatch,
        ENTITY_NAME.CASE_DOCUMENTS_LOWER
      )
      setCaseDocumentId(caseEntityData?.id)
    }

    const fetchServices = async () => {
      const allServices = await getEntityList({
        entity_name: ENTITY_NAME.SERVICES,
        embedded_name: ENTITY_NAME.SERVICE_NAME_KEY,
      })

      if (allServices) {
        setAllServices(allServices?.data?.content)
      }
    }

    fetchCaseId()
    fetchServices()
  }, [])

  useEffect(() => {
    if (programId && productId) fetchWorkFlowInstance()
  }, [programId, productId])

  useEffect(() => {
    const fetchLayoutIdForHcpEntity = async () => {
      const response = await fetchLayoutIdByEntityId(
        dispatch,
        Number(entityId),
        QUEUE_STRINGS?.EDIT_MODE
      )
      const layoutIdForHcpEntity = response.find(
        (item: { entity_name: string }) =>
          item.entity_name === QUEUE_STRINGS.HCP_PORTAL_ENTITY_LOWERCASE
      ).id
      setLayoutIdForHcpEntity(layoutIdForHcpEntity)
    }
    if (entityName === QUEUE_STRINGS.HCP_PORTAL_ENTITY_LOWERCASE) {
      fetchLayoutIdForHcpEntity()
    }
  }, [entityId])

  useEffect(() => {
    if (recordId) {
      setOpenCaseDetails(
        checkIfFromAttachCase(recordId) ?? {
          value: false,
          id: '',
          type: '',
        }
      )
    }
  }, [recordId])

  return (
    <div
      className={`flex flex-col bg-inherit h-full overflow-y-auto ${maxHeight}`}
    >
      <div className="bg-white rounded shadow flex flex-col resize-panel mt-4">
        <div className={`${loading ? 'visible' : 'hidden'}`}>
          <Loader isGlobal={true} loaderHeight={'126'} loaderWidth={'126'} />
        </div>
        {(viewCaseRecord || editCaseRcord) && (
          <div className="flex justify-between items-center">
            <div>
              <span
                className="font-medium text-base font-primary cursor-pointer"
                onClick={() => {
                  setViewCaseRecord(false)
                  setEditCaseRecord(false)
                  setOpenCaseDetails({ value: false, id: '', type: '' })
                }}
                onKeyDown={() => {
                  setViewCaseRecord(false)
                  setEditCaseRecord(false)
                  setOpenCaseDetails({ value: false, id: '', type: '' })
                }}
                // tabIndex={isBackButtonDisabled ? -1 : 0}
              >
                Advanced Search {''}
              </span>
              <span
                className={`font-medium text-base font-primary cursor-pointer ${
                  viewCaseRecord || editCaseRcord ? 'text-primary-500' : ''
                }`}
              >
                {`/ ${viewCaseRecord ? 'View' : 'Edit'} Case`}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <div className="flex gap-2">
                {viewCaseRecord && (
                  <CustomButton
                    type="button"
                    onClick={(e) => {
                      e.preventDefault()
                      openNewWindow(
                        `/entity/${entityId}/workflow/review/${
                          recordId || openCaseDetails.id
                        }`
                      )
                    }}
                    color="primary"
                  >
                    {NAMESPACES.GO_TO_WORKFLOW}
                  </CustomButton>
                )}

                {!editCaseRcord && (
                  <CustomButton
                    type="button"
                    onClick={() => {
                      // navigate(`/${entitiesRoute}/${entityId}/${editRoute}/${dataId}`)
                      setEditCaseRecord(true)
                      setViewCaseRecord(false)
                    }}
                    color="primary"
                    isFilled
                    className="border flex items-center justify-center"
                    // disabled={isReadOnlyUser()}
                  >
                    <div className="flex items-center justify-center gap-[0.25rem]">
                      <SvgEdit
                        width={'0.75rem'}
                        height={'0.75rem'}
                        className="svg-path-stroke-accent-0"
                      />
                      <span className="text-accent-0 text-sm">
                        {NAMESPACES.EDIT}
                      </span>
                    </div>
                  </CustomButton>
                )}
              </div>
            </div>
          </div>
        )}

        {openCaseDetails.value ? (
          editCaseRcord ? (
            <AddEditRecordPage
              mode={MODE_CONSTANTS?.EDIT}
              id={openCaseDetails?.id}
              entityId={caseEntityId}
              isHideAuditButton={true}
              allowNavigate={false}
              isFromIntake={true}
              isWorkflow={true}
              onIntakeHeaderSave={() => {
                setOpenCaseDetails({
                  value: false,
                  id: '',
                  type: '',
                })
                setEditCaseRecord(false)
                setViewCaseRecord(false)
              }}
              onIntakeHeaderCancel={() => {
                setOpenCaseDetails({
                  value: false,
                  id: '',
                  type: '',
                })
                setEditCaseRecord(false)
                setViewCaseRecord(false)
              }}
            />
          ) : (
            <IntakeReviewLayoutWrapper
              mode={getCaseDetailsType(openCaseDetails.type)}
              id={openCaseDetails.id}
              entityId={caseEntityId}
              isEdit={false}
              isHideAuditButton={true}
              allowNavigate={false}
              onCancel={(_, view) => onCloseDetailsModal(false, view)}
              isAttachCase={true}
              onAttachClick={() => attachmentSubmit(openCaseDetails.id)}
              onSaveClick={() => onCloseDetailsModal(false, undefined, true)}
              isFromIntake={true}
              isWorkflow={true}
              layoutId={openCaseDetails?.layoutId ?? ''}
            />
          )
        ) : (
          hasPermissionForWorkflow()
        )}
        {modal.state && (
          <Modal
            isOpen={modal.state}
            closeModal={() => setModal({ state: false, documentId: null })}
            width="w-[80%]"
            className="flex"
            closeModalOnOutsideClick={false}
          >
            <CaseDocumentModal
              caseDocumentEntityId={caseDocumentId ?? 0}
              onSaveClick={() => {
                setModal({ state: false, documentId: null })
                setOpenCaseDetails({
                  value: true,
                  id: caseId.toString(),
                  type: 'edit',
                })
                sessionStorage.setItem(
                  CHECK_ATTACH_IF_CASE,
                  JSON.stringify({
                    value: true,
                    id: caseId.toString(),
                    type: 'edit',
                  })
                )
                updateStatusToCompleted()
                // TODO: may require later when navigating to workflow
                // navigate(`/entity/${caseEntityId}/workflow/review/${caseId}`)
              }}
              documentId={modal?.documentId ?? 0}
              onCloseModal={() => setModal({ state: false, documentId: null })}
            />
          </Modal>
        )}
      </div>
    </div>
  )
}

const CaseDocumentModal: React.FC<CaseDocumentProps> = ({
  caseDocumentEntityId,
  onSaveClick,
  documentId,
  onCloseModal,
}: CaseDocumentProps) => {
  return (
    <div className="flex items-center justify-center mt-2 w-full h-full case_document_modal">
      <AddEditRecordPage
        mode={'edit'}
        id={documentId?.toString()}
        entityId={caseDocumentEntityId?.toString()}
        isEdit={false}
        isHideAuditButton={true}
        allowNavigate={false}
        onCancel={() => onCloseModal()}
        onSaveClick={() => onSaveClick()}
        isFromIntake={true}
      />
    </div>
  )
}

export default SelectCase
